import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { changeSessionState, selectCurrentSessionState, selectSessionId } from '../../app/slices/session.slice';
import sessionService from '../../services/session.service';
import { ConsumerInputNeededState } from '../../types/session';

const OBSERVATION_REQUEST_DELAY = 3000;

export const usePolling = () => {
	const state = useAppSelector(selectCurrentSessionState) as unknown as ConsumerInputNeededState;
	const sessionId = useAppSelector(selectSessionId);
	const dispatch = useAppDispatch();
	useEffect(() => {
		if (!state.polling || !sessionId) {
			return;
		}
		const ref = setInterval(async () => {
			try {
				const nextState = await sessionService.getSessionState(sessionId);
				dispatch(changeSessionState(nextState));
			} catch (_) {}
		}, OBSERVATION_REQUEST_DELAY);

		return () => {
			clearInterval(ref);
		};
	}, [state.polling, sessionId]);
};
